import '../../css/mk-brand.css';
import {useEffect, useState, useRef} from "react";
import {gPageView} from "../../google-analytics";
import gameApi from "../../lib/game-api";

function useInterval(callback, delay) {
    const intervalRef = useRef(null);
    const savedCallback = useRef(callback);
    useEffect(() => {
        savedCallback.current = callback;
    }, [callback]);
    useEffect(() => {
        const tick = () => savedCallback.current();
        if (typeof delay === 'number') {
            intervalRef.current = window.setInterval(tick, delay);
            return () => window.clearInterval(intervalRef.current);
        }
    }, [delay]);
    return intervalRef;
}

function ShowRealPanel({onChangePanel, frames, playerPK, replay = false}) {
    const [index, setIndex] = useState(0);
    const [delay, setDelay] = useState(frames[0]?.duration); // must set first frame duration;
    const [muted, setMuted] = useState(false);

    useEffect(async () => {
        gPageView('super-og-show-reel');
        if (replay) {
            setIndex(0);
        }
    }, [replay]);
    useEffect(() => {
        window.addEventListener('touchstart', () => {
            document.getElementById('audio').muted = false;
            document.getElementById('audio').play();
        })
    })
    useInterval(() => {
        if (index < frames.length-1) {
            const nextIndex = index + 1;
            setIndex(nextIndex);
            setDelay(frames[nextIndex].duration);
        } else {
            setDelay(0);
        }
    }, delay);
    return (
        <div id="super-og-set" className="m-2 relative">
            <audio id="audio" autoPlay playsInline muted={muted}>
                <source src={gameApi.makeAbsolutePath('/music.mp4')} />
            </audio>
            <div className="z-30 container w-full">
                <div className=" bg-zinc-800 pt-4 px-4 md:mx-32 pb-4 rounded-lg">
                    {muted ? <div className="bg-brand cursor-pointer rounded-lg p-1 m-1 text-xl fa fa-volume-mute" onClick={()=>{setMuted(false);}} /> : <div className="bg-brand cursor-pointer rounded-lg m-1 p-1 text-xl fa fa-volume-up" onClick={()=>{setMuted(true);}} />}
                    {frames[index]?.content}
                </div>
            </div>
        </div>
    );
}
export default ShowRealPanel;